import React, { Component } from 'react';
import axios from '../../axios-signup';
import { Redirect } from 'react-router-dom';
import Error from '../../components/UI/Error';
import wrapper from "../../hoc/wrapper";
import Header from "../../components/Header/Header";
import {Loader} from 'react-overlay-loader';
import PasswordStrengthBar from 'react-password-strength-bar';

class Password extends Component {

    state = {
        emailAddress: this.props.location.state.emailAddress,
        valid: this.props.location.state.valid,
        linkExpired : this.props.location.state.linkExpired,
        password: '',
        showPassword: false,
        submitted: false,
        errorMsg: '',
        unauthorized: false,
        loading: false
    };

    onSubmit = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        axios.post('/password', {
            emailAddress: this.state.emailAddress,
            password: this.state.password
        }).then(res => {
            this.setState({submitted: true, loading: false})
        }).catch(
            err => {
                if (err.response.status === 401) {
                    this.setState({unauthorized: true, loading: false})
                } else {
                    this.setState({errorMsg: err.response.data.error, loading: false})
                }
            })
    };

    onChange = (event) => {
        this.setState({password: event.target.value})
    };

    togglePassword = (event) => {
        event.preventDefault();
        let showPw = this.state.showPassword;
        this.setState({showPassword: !showPw});
    };

    handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            this.setState({loading: true});
            axios.post('/password', {
                emailAddress: this.state.emailAddress,
                password: this.state.password
            }).then(res => {
                this.setState({submitted: true, loading: false})
            }).catch(
                err => {
                    if (err.response.status === 401) {
                        this.setState({unauthorized: true, loading: false})
                    } else {
                        this.setState({errorMsg: err.response.data.error, loading: false})
                    }
                })
        }
    };
    render() {
        let verifyRes = null;
        let invalidReason = null;
        if (this.state.valid) {
            verifyRes = <h2 className="mb-5">Email Successfully Validated!</h2>
        } else {
            if (this.state.linkExpired) {
                invalidReason = "The Email verification link already expired."
            }
            verifyRes = <h2 className="mb-5">Email Not Validated! {invalidReason}</h2>
        }

        let passwordInput = null;
        if (this.state.showPassword) {
            passwordInput = <input type="text" className="form-control" autocomplete="new-password" maxLength="128" value={this.state.password} onChange={this.onChange} onKeyPress={e => this.handleKeyPress(e)}/>
        } else {
            passwordInput = <input type="password" className="form-control" autocomplete="new-password" maxLength="128" value={this.state.password} onChange={this.onChange} onKeyPress={e => this.handleKeyPress(e)}/>
        }

        let redirect = null;
        if (this.state.submitted) {
            redirect = <Redirect to={{pathname: '/signup/customer-info', state: {emailAddress: this.state.emailAddress}}}/>
        } else if (this.state.unauthorized) {
            redirect = <Redirect to="/signup/"/>
        }


        return (
            <div>
                <Header currentWizard="3"/>
            <main role="main">
                <Loader fullPage={true} loading={this.state.loading}/>
                <section className="section yellow">
                    {redirect}
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 col-center text-center">
                                {verifyRes}
                                <h1 className="black"><strong>Select Password</strong></h1>
                                <p>Select a password to use below. Your password should be at least 8 characters and
                                    include at least one upper case letter, one lower case letter, and one number or
                                    special character.</p>
                                <Error errorMsg={this.state.errorMsg} divClass="col-lg-6 col-md-7 col-sm-7 col-center"/>
                                <div className="row">
                                    <div className="col-lg-6 col-md-7 col-sm-7 col-center">
                                        <div className="form-group row no-gutters">
                                            <div className="col-11">
                                                {passwordInput}
                                                <PasswordStrengthBar password={this.state.password} />
                                            </div>
                                            <div className="col-1">
                                                <div className="mt-2">
                                                    <a href="{null}" className="gray" onClick={this.togglePassword}><i className="fa fa-eye"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <input type="submit" value="Set Password" className="btn btn-primary" onClick={this.onSubmit}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            </div>
        )
    }
}

export default wrapper(Password);